import React,{useState,useEffect} from 'react'
import Loading from '../../../common/Loading'
import settingsService from '../../../../services/settings.service'
import { useEyeconxStore } from '../../../../store/eyeconxStore'
import RecallHoursText from './RecallHoursText'

function RecallHours() {
    const [isLoading,setIsLoading] = useState(true)
    const [clinicHours,setClinicHours] = useState(null)
    const clinicId = useEyeconxStore(state => state.user.clinicId)
    useEffect(()=>{
            
                getRecallHours()
           },[clinicId])
     const getRecallHours = ()=>{
            setIsLoading(true)
            settingsService.getRecallHours(clinicId)
            .then(res=>{
                setClinicHours(res.data)
                setIsLoading(false)
            })
            .catch(err=>{
                console.log("Error while getting Clinic Recall Hours ")
                setIsLoading(false)
            })
         }
  return (
  
    <>
    <div className="row mb-4">
        <div className="col-12">
                <div className="d-flex justify-content-between">
                    <h1>Clinic Recall Hours</h1>
                   
                      </div>
        </div>
    </div>
    <div className="separator border-2 my-5"></div>
    {  isLoading?<Loading/> : 
        <RecallHoursText clinicHours={clinicHours} /> }
    </>
 
    )
  
}

export default RecallHours